import { hasMediaProcessorSupport } from '@opentok/client';
import { GrowthBookFeatures } from './../constants/growthbook';
import { AngularServices, getAngularService } from './get-angular-service';
import { isDoctor } from '../../call/helpers';
import { browser } from '../../../common/services/browser';
import { StreamType } from '../../call/constants';
import { store } from '../../../store/store';
import { canUsePaidFeatures } from '../../../store/features/system';
export const setBetaFeatures = (betaFeatures) => {
    const rootScope = getAngularService(AngularServices.RootScope);
    for (const betaAccess of betaFeatures) {
        rootScope.globalState.beta[betaAccess.feature] = true;
    }
};
export const hasBetaFeature = (flag) => {
    return getAngularService(AngularServices.RootScope).globalState.beta[flag];
};
export const hasGrowthBookFeature = (feature) => {
    return window.growthbookInstance.feature(feature).on;
};
export const getGrowthBookFeatureValue = (feature) => {
    return window.growthbookInstance.feature(feature).value;
};
export const isMobileUISupported = () => {
    const activeComponents = getAngularService(AngularServices.ActiveComponents);
    const { activeProvider } = getAngularService(AngularServices.VideoProviderFactory);
    const isGroupCallWithBetaEnabled = Boolean(activeProvider.isInGroupCall &&
        activeComponents.phone?.options?.mobileGroupUI);
    const hasScreenStream = activeProvider.streams.some((s) => s.type === StreamType.Screen);
    return (hasScreenStream || isGroupCallWithBetaEnabled) && browser.isMobile;
};
export function canSeeBackgroundEffects() {
    return isDoctor() && browser.isDesktop && hasMediaProcessorSupport();
}
export function canUseBackgroundEffects() {
    return (canSeeBackgroundEffects() &&
        (canUsePaidFeatures(store.getState()) ||
            hasGrowthBookFeature(GrowthBookFeatures.BackgroundEffects)));
}
